import { render, staticRenderFns } from "./SeniorMenuList.vue?vue&type=template&id=4cb6fdd6&"
import script from "./SeniorMenuList.vue?vue&type=script&lang=js&"
export * from "./SeniorMenuList.vue?vue&type=script&lang=js&"
import style0 from "./SeniorMenuList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports